/* Time for Tea — shared page behavior (header, overlay menu, reveal, scroll-top) */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* --- Header shrink on scroll --- */
    var header = document.getElementById("tft-header");
    var logo = document.getElementById("tft-header-logo");
    function onScroll() {
      var scrolled = window.scrollY > 24;
      if (header) header.classList.toggle("tft-scrolled", scrolled);
      if (logo) logo.classList.toggle("tft-scrolled", scrolled);
      var topBtn = document.getElementById("tft-scroll-top");
      if (topBtn) topBtn.classList.toggle("tft-visible", window.scrollY > 600);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    /* --- Header: ホーム dropdown of home page sections ---
       ホーム is a real link: clicking it goes to the home page, hovering or
       focusing it opens the list of that page's sections. Where there is no
       hover (touch), the first tap opens the list instead of navigating, so the
       sections stay reachable; a second tap on it follows the link. */
    var navGroups = Array.prototype.slice.call(document.querySelectorAll(".tft-nav-group"));

    navGroups.forEach(function (group) {
      var trigger = group.querySelector(".tft-nav-link");
      var menu = group.querySelector(".tft-nav-dropdown");
      if (!trigger || !menu) return;

      var closeTimer = null;

      function setMenu(open) {
        window.clearTimeout(closeTimer);
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
      }

      /* A short grace period on the way out forgives an imprecise mouse; the
         gap itself is bridged in CSS. */
      function closeSoon() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () { setMenu(false); }, 180);
      }

      trigger.addEventListener("click", function (e) {
        var noHover = window.matchMedia && window.matchMedia("(hover: none)").matches;
        if (noHover && menu.hidden) {
          e.preventDefault();
          setMenu(true);
        }
      });

      group.addEventListener("mouseenter", function () {
        /* Opening one closes any other, so two panels can't overlap. */
        navGroups.forEach(function (other) {
          if (other === group) return;
          var m = other.querySelector(".tft-nav-dropdown");
          var t = other.querySelector(".tft-nav-link");
          if (m) m.hidden = true;
          if (t) t.setAttribute("aria-expanded", "false");
        });
        setMenu(true);
      });
      group.addEventListener("mouseleave", closeSoon);

      trigger.addEventListener("focus", function () { setMenu(true); });

      /* Tabbing on past the group should not leave an orphaned panel open. */
      group.addEventListener("focusout", function (e) {
        if (!group.contains(e.relatedTarget)) setMenu(false);
      });

      menu.addEventListener("click", function () { setMenu(false); });

      document.addEventListener("click", function (e) {
        if (!group.contains(e.target)) setMenu(false);
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" || e.key === "Esc") setMenu(false);
      });
    });

    /* --- Fullscreen overlay menu --- */
    var menu = document.getElementById("tft-menu");
    function setMenu(open) {
      if (!menu) return;
      menu.classList.toggle("tft-open", open);
      document.body.style.overflow = open ? "hidden" : "";
      /* Lets a page hide its own fixed furniture while the overlay is up. The
         cake order form's bottom bar sits at z-index 100 against this menu's
         50, so it stayed on top of the overlay and was still tappable. */
      document.body.classList.toggle("tft-menu-open", open);
    }
    document.querySelectorAll("[data-tft-menu-open]").forEach(function (el) {
      el.addEventListener("click", function () { setMenu(true); });
    });
    document.querySelectorAll("[data-tft-menu-close]").forEach(function (el) {
      el.addEventListener("click", function () { setMenu(false); });
    });
    if (menu) {
      menu.querySelectorAll("nav a").forEach(function (a) {
        a.addEventListener("click", function () { setMenu(false); });
      });
    }

    /* --- Scroll to top --- */
    var topBtn = document.getElementById("tft-scroll-top");
    if (topBtn) {
      topBtn.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    /* --- Reveal on scroll (IntersectionObserver) --- */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal:not(.is-visible)").forEach(function (el) {
      io.observe(el);
    });
  });
})();
